import { Component, OnInit, trigger, state, style, transition, animate, Input,  Output, EventEmitter } from '@angular/core';

import { DonneeService } from './../services/donnee.service';

@Component({
  selector: 'cm-favoris',

  template: `
    <div class="ecran-favoris" 
        [@afficherCacherEcran]="etatEcran">

        <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

        <div class="cadre-defilement">

          <div class="cadre-entete">
            <h3>Mes favoris</h3>
            <i class="fa fa-star etoile-favoris" aria-hidden="true"></i>
          </div>

          <div class="cadre-resultat">
              <div class="cadre-reinitialiser text-right"> 
                <span class="texte-reinitialiser" (click)="reinitialiserFavoris()"> Réinitialiser les favoris </span>
              </div>
              <cm-recherche-resultat
                  *ngFor="let site of sitesFavoris"
                  [site]="site"
                  [favoris]="true"
                  (selectionner)="selectionnerSite($event)"
                  (enleverFavoris)="enleverFavoris($event)">
              </cm-recherche-resultat>

              <div *ngIf="sitesFavoris && sitesFavoris.length === 0"> 
                Aucun sites favoris <br> Vous pouvez en ajouter en cliquant sur les <i class="fa fa-star-o etoile-favoris" aria-hidden="true"></i>
              </div>

          </div>

        </div>

    </div>
  `,

  styles: [`
    .ecran-favoris {
      position: absolute;
      top: 0;
      left: 60vw;
      width: calc(40vw - 60px);
      height: calc(100vh - 50px);
      background-color: white;
      border: 1px solid lightgray;
      overflow: hidden;
    }
    .cadre-defilement {
        padding: 30px 0px 0px 0px;
        height: calc(100vh - 50px - 50px);
        overflow-x: hidden;
        overflow-y: auto;
      }
      .cadre-fermer {
          height: 50px;
      }
      .image-fermer {
          position: relative;
          top: 10px;
          left: calc(100% - 40px);
          width: 25px;
          height: 25px;
          cursor: pointer;
      }
    .cadre-entete {
        padding: 30px 45px 0px 45px;
        display: flex;
    }
    .fa {
      font-size: 26px;
      color: #FFA300;
    }
    .cadre-entete .etoile-favoris {
      position: relative;
      left: 15px;
      top: 23px;
    }
    .cadre-reinitialiser {
        color: darkgray;
        padding: 20px;
    }
    .texte-reinitialiser {
        cursor: pointer;
    }
    .cadre-resultat {
      margin-top: 30px;
      background-color: rgb(233, 233, 233);
      border-top: 1px solid lightgray;
      padding-left: 35px;
      padding-bottom: 30px;
    }


    @media (max-width: 800px), (max-height: 700px) { 
      .ecran-favoris {
          left: 0;
          width: 100vw;
          height: 100vh;
          padding: 20px 0 20px 0;
      }
      .cadre-entete {
        padding: 0px 25px 0px 25px;
        display: flex;
    }
    }
  `],

  animations: [
    trigger('afficherCacherEcran', [
      state('visible', style({
      transform: 'translateX(0) scale(1, 1)'
      })),
      state('invisible', style({
          transform: 'translateX(100%) scale(0, 1)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ]),
  ]
})
export class FavorisComponent implements OnInit {
  @Input() etatEcran: string;
  @Input() sitesFavoris: any[];
  @Output() fermerEcran: EventEmitter<any> = new EventEmitter();
  @Output() selectionner: EventEmitter<any> = new EventEmitter();

  constructor(
    private donneeService: DonneeService
  ) {}

  ngOnInit() {
  }

  fermer() {
    this.fermerEcran.emit();
  }

  selectionnerSite(site: any) {
    this.fermer();
    this.selectionner.emit(site);
  }

  reinitialiserFavoris() {
      this.sitesFavoris = [];
      this.donneeService.enregistrerIdFavoris(this.sitesFavoris);
  }

  enleverFavoris(site: any) {
    let index = this.sitesFavoris.indexOf(site, 0);
    if (index > -1) {
      this.sitesFavoris.splice(index, 1);
    }
    this.donneeService.enregistrerIdFavoris(this.sitesFavoris);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/favoris.component.ts